import CSSVariables from "./CSSVariables";

export default CSSVariables;
